export default "__VITE_ASSET__$6EG_tmH__"